var map = {
	"./csv.png": 56051,
	"./del.png": 10540,
	"./excel.png": 79610,
	"./folder.png": 54055,
	"./image.png": 90004,
	"./other.png": 83989,
	"./pdf.png": 11577,
	"./ppt.png": 64983,
	"./radio.png": 53114,
	"./sql.png": 38775,
	"./svg.png": 39721,
	"./txt.png": 20699,
	"./viedo.png": 41540,
	"./word.png": 64931,
	"./zip.png": 29846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;